import { AuthorizationPage } from 'pages/Accounts';
import { appRouterPaths } from 'services/navigation';
import type { AppRouteProps } from '../types';

export const authorizationPageRoute: AppRouteProps = {
  path: appRouterPaths.authorization,
  element: <AuthorizationPage />,
};
